// extracted by mini-css-extract-plugin
export var heading = "v3-image-module--heading--3e67c";
export var image = "v3-image-module--image--077fa";
export var imageContainer = "v3-image-module--imageContainer--49e1e";
export var text = "v3-image-module--text--7c3a5";